import React, { Component } from 'react'

export default class SelectedSideDishListing extends Component {
  render() {
        const { order } = this.props
        let sideDishSelection = []
        if (order.side_dish_data && order.side_dish_data.selections && Array.isArray(order.side_dish_data.selections)) {
            sideDishSelection = order.side_dish_data.selections
        }
        return (
            <>
                {
                    sideDishSelection.map((sd, index) => {
                        return <div key={index}>
                            - {sd.quantity > 1 && `${sd.quantity}x`} {sd.variation.name}
                        </div>
                    })
                }
            </>
        )
  }
}